import { getMeta } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';

const FollowNotification = ({ notification }) => {
  const meta = getMeta(notification);

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} />
      <div className="my-auto ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> started following you</span>
        </p>
      </div>
    </div>
  );
};

export default FollowNotification;
